/**
 * Created by Administrator on 2017-11-3.
 */
export function getRightHeight(cls, search = 0) {
  let height = document.getElementById('app').clientHeight
  let container = document.getElementsByClassName(cls)
  if (container) {
    if (cls === 'rightContent') {
      container[0].style.height = height
    } else {
      container[0].style.height = height
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/js/rightHeight.js